import React from 'react';
import Div from '../Div';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import Newsletter from '../Widget/Newsletter';
import SocialWidget from '../Widget/SocialWidget';
import TextWidget from '../Widget/TextWidget';
import './footer.scss';
const copyrightLinks = [
  {
    title: 'Terms & Conditions',
    href: '/terms-and-conditions',
  },
  {
    title: 'Privacy Policy',
    href: '/privacy-policy',
  },
  {
    title: 'Refund Policy',
    href: '/refund-policy',
  },
  {
    title: 'Dispute Resolution',
    href: '/dispute-resolution',
  },
];

const serviceMenu = [
  {
    title: 'Web Solutions',
    href: '/service/web-solutions',
  },
  {
    title: 'Mobile Solutions',
    href: '/service/mobile-solutions',
  },
  {
    title: 'Enterprise Solutions',
    href: '/service/enterprise-solutions',
  },
  {
    title: 'Billing & Payments',
    href: '/service/billing-payments',
  },
  {
    title: 'Other IT Solutions',
    href: '/service/other-it-solutions',
  },
];

export default function Footer({ copyrightText, logoSrc, logoAlt, text }) {
  return (
    <footer className="cs-fooer">
      <Div className="cs-fooer_main">
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <TextWidget
                  logoSrc="/images/footer_logo.svg"
                  logoAlt="TUR DER HOFFNUNG"
                  text="TUR DER HOFFNUNG, 50 Rawdon Street, Freetown, Sierra Leone. TIN: 1001205375. Company No: SL280624TURDE22311. Website: https://turderhoffnung.com"
                />
                <SocialWidget />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu} menuHeading="Services" />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <ContactInfoWidget title="Contact Us" />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <Newsletter
                  title="Subscribe"
                  subtitle="Stay updated with our latest projects and technology insights."
                  placeholder="example@gmail.com"
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright">Copyright © 2025 TUR DER HOFFNUNG. All rights reserved.</Div>
          </Div>
          <Div className="cs-bottom_footer_right">
            <MenuWidget menuItems={copyrightLinks} variant=" cs-style2" />
          </Div>
        </Div>
      </Div>
    </footer>
  );
}
